package com.gsb.vyapar.bhagya.datasource.runtimecache

import com.gsb.vyapar.bhagya.datasource.preference.Preference

object RuntimeCache {
    var accessToken = Preference.accessToken
    var refreshToken = Preference.refreshToken

    fun setTokens(accessToken: String, refreshToken: String) {
        this.accessToken = accessToken
        Preference.accessToken = accessToken
        this.refreshToken = refreshToken
        Preference.refreshToken = refreshToken
    }
}